import {Engine} from "platform/engine/Engine";
import {DoSubmitDepositCCPayload} from "core/redux/deposit/DepositReduxActions";
import Platform from "platform/Platform";
import {PageType} from "enum/PageType";
import {HideLoader, NavigateTo, SetLoader} from "platform/redux/core/CoreActions";
import {LoaderType} from "platform/enum/LoaderType";
import {ShowPopup} from "platform/redux/popups/PopupsActions";
import {PopupActionType, PopupIconType, PopupType} from "platform/redux/popups/PopupsReduxState";

export default class DepositEngine extends Engine {

    private static _instance: DepositEngine;
    private _attempt: number = 0;

    public static instance(): DepositEngine {
        return this._instance || (this._instance = new this());
    }

    public async setup(): Promise<void> {
        await super.setup();
    }

    public doSubmitDepositCC = ({values}: DoSubmitDepositCCPayload) => {
        this._logger.debug("Submit deposit with amount: " + values.amount);
        Platform.dispatch(SetLoader({loaderType: LoaderType.FullScreen}));
        setTimeout(() => {
            Platform.dispatch(HideLoader({}));
            // TODO Get actual response from server
            if (++this._attempt % 2 === 0) {
                Platform.dispatch(NavigateTo({route: PageType.DepositSuccessful}));
            } else {
                Platform.dispatch(ShowPopup({
                    popup: {
                        type: PopupType.ERROR,
                        message: {
                            customValue: "Failed deposit"
                        },
                        showClose: true,
                        icon: PopupIconType.ERROR,
                        actions: [{type: PopupActionType.OK}]
                    }
                }));
            }
        }, 1000);
    }
}
